import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { AiFillPlayCircle } from "react-icons/ai";
import { useFunctions } from "reactfire";
import {
  SubsectionStatus,
  useAppUser,
} from "../../../../../../contexts/user-context/UserContext";
import {
  useWorkShop,
  WorkshopSectionContent,
  WorkshopSectionContentType,
} from "../../../../../../contexts/workshop-context/WorkshopContext";
import ConfirmationModal from "../../../../../../shared/components/confirmationModal/ConfirmationModal";
import getIconByType from "../../../../../../shared/resources/file-types/file-types";
import { MediaFileContent } from "../../../update-workshops/components/media-card/MediaCard";
import { MediaURLContent } from "../../../update-workshops/components/media-card/url/MediaURL";
import "./styles.scss";
import { ClipLoader } from "react-spinners";
import { HiLink } from "react-icons/hi";
// @ts-ignore
import renderHTML from "react-render-html";

interface IProps {
  isArchived: boolean;
}
const SubSection = (props: IProps) => {
  const workshop = useWorkShop();
  const appUser = useAppUser();

  const [showNextConfirmation, setShowNextConfirmation] = useState(false);
  const [showFinishConfirmation, setShowFinishConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);

  const [allWatched, setAllWatched] = useState(false);

  useEffect(() => {
    const rs = workshop.selectedSubSection.workshopSectionContent;

    if (
      rs.filter((r) => r.wached).length ===
      rs.filter((r) => r.type === WorkshopSectionContentType.VIDEO_URL).length
    ) {
      setAllWatched(true);
    } else {
      setAllWatched(false);
    }
  }, [
    workshop.selectedSubSection.workshopSectionContent,
    appUser.workshopProgress,
  ]);

  const watchVideoFunctionRef = useFunctions().httpsCallable(
    "updateWatchedStatus"
  );

  const watchVideo = (resource: WorkshopSectionContent) => {
    if (!resource.wached) {
      watchVideoFunctionRef({
        workshopId: workshop.id,
        currentSubsectionId: workshop.selectedSubSection.id || "",
        contentId: resource.id,
      })
        .then(() => {
          workshop.updateResource(workshop.selectedSubSection, {
            ...resource,
            wached: true,
          });
        })
        .catch((err) => console.log("error", err));
    }
  };

  const getURLContent = (content: string): MediaURLContent => {
    try {
      const data = JSON.parse(content);
      if (data) {
        return data;
      } else {
        return { text: content, url: content };
      }
    } catch (e) {
      return { text: content, url: content };
    }
  };

  const getFileContent = (content: string): MediaFileContent => {
    try {
      const data: MediaFileContent = JSON.parse(content);
      if (data) {
        return data;
      } else {
        return { fileName: data, url: data, type: "all" };
      }
    } catch (e) {
      return { fileName: "Download file", url: content, type: "all" };
    }
  };

  const getResourcePreview = (resource: WorkshopSectionContent) => {
    switch (resource.type) {
      case WorkshopSectionContentType.URL:
        return (
          <div
            className="d-flex"
            style={{ fontSize: "24px", marginBottom: "16px" }}
          >
            <div style={{ marginRight: "15px" }}>
              <HiLink />
            </div>
            <a
              href={getURLContent(resource.content).url}
              rel="noopener noreferrer"
              target="_blank"
            >
              {getURLContent(resource.content).text}
            </a>
          </div>
        );
      case WorkshopSectionContentType.TEXT:
        return (
          <p
            className="text-justify"
            style={{ color: "#646464", fontSize: "24px", marginBottom: "16px" }}
          >
            {renderHTML(resource.content)}
          </p>
        );
      case WorkshopSectionContentType.IMAGE_URL:
        return (
          <div className="text-center" style={{ marginBottom: "16px" }}>
            <img
              src={getFileContent(resource.content).url}
              key={getFileContent(resource.content).url}
              style={{ width: "40%" }}
              alt=""
            />
          </div>
        );
      case WorkshopSectionContentType.FILE_URL:
        return (
          <div
            className="text-left"
            style={{
              marginBottom: "16px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={getIconByType(getFileContent(resource.content).type)}
              alt=""
              key={getIconByType(getFileContent(resource.content).type)}
              style={{ width: "30px" }}
            />
            <a
              style={{ fontSize: "24px", marginLeft: "10px" }}
              href={getFileContent(resource.content).url}
              rel="noopener noreferrer"
              target="_blank"
            >
              {getFileContent(resource.content).fileName}
            </a>
          </div>
        );
      default:
        return (
          <video
            style={{ width: "100%", cursor: "default", marginBottom: "16px" }}
            controls
            controlsList="nodownload"
            key={getFileContent(resource.content).url}
            onPlaying={(e) => watchVideo(resource)}
            onContextMenu={(e) => e.preventDefault()}
          >
            <source src={getFileContent(resource.content).url} />
          </video>
        );
    }
  };

  return (
    <Container fluid className="st-subsection-preview">
      <Row>
        <Col xs={12} className="mb-4">
          <label className="font-weight-bold subsection-summery-title">
            {workshop.selectedSubSection.subSectionTitle}
          </label>
        </Col>
      </Row>
      {workshop.selectedSubSection.workshopSectionContent.map((res) => (
        <Row key={res.orderNo} className="p-0">
          <Col xs={12}>{getResourcePreview(res)}</Col>
        </Row>
      ))}

      {workshop.selectedSubSection.status && !props.isArchived && (
        <Row>
          <Col xs={12} className="d-flex justify-content-between">
            {workshop.selectedSubSection.orderNo !== 0 ? (
              <button
                className="stsub-action-button"
                onClick={() => {
                  workshop.setSelectedSubSection(
                    workshop.workshopSections.filter(
                      (s) =>
                        s.orderNo === workshop.selectedSubSection.orderNo - 1
                    )[0]
                  );
                }}
              >
                <AiFillPlayCircle
                  style={{ marginRight: "15px", transform: "rotateY(180deg)" }}
                />
                Previous
              </button>
            ) : (
              <div></div>
            )}
            {workshop.workshopSections.length - 1 ===
            workshop.selectedSubSection.orderNo ? (
              <>
                {(workshop.selectedSubSection.status ===
                  SubsectionStatus.CURRENT ||
                  workshop.selectedSubSection.status ===
                    SubsectionStatus.SKIPPED) && (
                  <button
                    className={
                      allWatched
                        ? "stsub-action-button"
                        : "stsub-action-button-disabled"
                    }
                    onClick={() => {
                      if (allWatched) {
                        setShowFinishConfirmation(true);
                      }
                    }}
                  >
                    Finish
                    <AiFillPlayCircle style={{ marginLeft: "15px" }} />
                  </button>
                )}
              </>
            ) : (
              <>
                {loading ? (
                  <span className="ml-3">
                    <ClipLoader size={25} color={"#006699"} loading={true} />
                  </span>
                ) : (
                  <button
                    className={
                      allWatched
                        ? "stsub-action-button"
                        : "stsub-action-button-disabled"
                    }
                    onClick={() => {
                      if (allWatched) {
                        if (
                          workshop.selectedSubSection.status ===
                          SubsectionStatus.CURRENT
                        ) {
                          // setShowNextConfirmation(true);

                          setLoading(true);
                          !loading &&
                            appUser.startNextSubsection(
                              workshop.id,
                              workshop.selectedSubSection.id || "",
                              workshop.workshopSections.filter(
                                (s) =>
                                  s.orderNo ===
                                  workshop.selectedSubSection.orderNo + 1
                              )[0].id || "",
                              () => {
                                workshop.setSelectedSubSection(
                                  workshop.workshopSections[
                                    workshop.selectedSubSection.orderNo + 1
                                  ]
                                );
                                setLoading(false);
                                // setShowNextConfirmation(false);
                                document.body.scrollTop = 0; // For Safari
                                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                              },
                              () => {
                                setLoading(false);
                                // setShowNextConfirmation(false);
                              }
                            );
                        } else if (
                          workshop.selectedSubSection.status ===
                          SubsectionStatus.SKIPPED
                        ) {
                          console.log("this is skipped secction");
                          setLoading(true);
                          !loading &&
                            appUser.completeSkippedSubsection(
                              workshop.id,
                              workshop.selectedSubSection.id || "",
                              () => {
                                workshop.setSelectedSubSection(
                                  workshop.workshopSections[
                                    workshop.selectedSubSection.orderNo + 1
                                  ]
                                );
                                setLoading(false);
                                document.body.scrollTop = 0; // For Safari
                                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                              },
                              () => {
                                setLoading(false);
                                // setShowNextConfirmation(false);
                              }
                            );
                        } else {
                          workshop.setSelectedSubSection(
                            workshop.workshopSections.filter(
                              (s) =>
                                s.orderNo ===
                                workshop.selectedSubSection.orderNo + 1
                            )[0]
                          );
                        }
                      }
                    }}
                  >
                    Next
                    <AiFillPlayCircle style={{ marginLeft: "15px" }} />
                  </button>
                )}
              </>
            )}
          </Col>
        </Row>
      )}
      <ConfirmationModal
        loading={loading}
        children={{
          headerText: "Subsection complete confirmation",
          bodyText: <p>Are you sure you want to start next section?</p>,
          cancelButtonText: "Cancel",
          confirmButtonText: "Start Next",
          confirmButtonColor: "blue",
        }}
        show={showNextConfirmation}
        onCancel={() => setShowNextConfirmation(false)}
        onConfirm={() => {
          setLoading(true);
          appUser.startNextSubsection(
            workshop.id,
            workshop.selectedSubSection.id || "",
            workshop.workshopSections.filter(
              (s) => s.orderNo === workshop.selectedSubSection.orderNo + 1
            )[0].id || "",
            () => {
              workshop.setSelectedSubSection(
                workshop.workshopSections[
                  workshop.selectedSubSection.orderNo + 1
                ]
              );
              setLoading(false);
              setShowNextConfirmation(false);
              document.body.scrollTop = 0; // For Safari
              document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            },
            () => {
              setLoading(false);
              setShowNextConfirmation(false);
            }
          );
        }}
      />
      <ConfirmationModal
        loading={loading}
        children={{
          headerText: "Workshop complete confirmation",
          bodyText: <p>Are you sure you want to complete this workshop?</p>,
          cancelButtonText: "Cancel",
          confirmButtonText: "Complete Workshop",
          confirmButtonColor: "blue",
        }}
        show={showFinishConfirmation}
        onCancel={() => {
          setShowFinishConfirmation(false);
        }}
        onConfirm={() => {
          setLoading(true);
          if (workshop.selectedSubSection.status === SubsectionStatus.SKIPPED) {
            appUser.completeSkippedSubsection(
              workshop.id,
              workshop.selectedSubSection.id || "",
              () => {
                setLoading(false);
                setShowFinishConfirmation(false);
                workshop.setSelectedSubSection({
                  ...workshop.selectedSubSection,
                  orderNo: -1,
                });
              },
              () => {
                setLoading(false);
                setShowFinishConfirmation(false);
              }
            );
          } else {
            appUser.finishWorkshop(
              workshop.id,
              workshop.selectedSubSection.id || "",
              () => {
                setLoading(false);
                setShowFinishConfirmation(false);
                workshop.setSelectedSubSection({
                  ...workshop.selectedSubSection,
                  orderNo: -1,
                });
              },
              () => {
                setLoading(false);
                setShowFinishConfirmation(false);
              }
            );
          }
        }}
      />
    </Container>
  );
};

export default SubSection;
